import { useIntl } from "react-intl";
import { InlineEdit } from "@/components/design/InlineEdit";
import { SearchableSelect } from "@/components/design/SearchableSelect";
import { DatePicker } from "@/components/design/DatePicker";
import { EVENT_KIND_LABELS, PROJECT_EVENT_KINDS, type ProjectEvent, type ProjectEventKind } from "./project-plan";

// Was im Bearbeitungskasten eines Termins steht: Titel, Datum und Art. Der Titel
// gehört hierher und nicht in die ruhende Zeile - dort ist er Text, und die
// Zeile als Ganzes öffnet diesen Kasten. Ein Feld, das schon in der Liste
// tippbar ist, fängt den Klick ab, der eigentlich der Zeile galt.
//
// Die Art ist ein festes Dreierwort, deshalb Auswahl ohne Suchzeile - dieselbe
// Entscheidung wie beim Anlass.

export function ProjectEventFields({
  event,
  onChange,
  idPrefix,
}: {
  event: ProjectEvent;
  onChange: (patch: Partial<ProjectEvent>) => void;
  /** Testanker: `${idPrefix}-title`, `-date`, `-kind`. */
  idPrefix?: string;
}) {
  const intl = useIntl();

  return (
    <div className="min-w-0">
      <InlineEdit
        id={idPrefix && `${idPrefix}-title`}
        value={event.title}
        clearable={false}
        inputClassName="font-medium"
        ariaLabel={intl.formatMessage({ id: "project.event.title", defaultMessage: "Termin" })}
        placeholder={intl.formatMessage({ id: "project.plan.unnamed", defaultMessage: "Ohne Namen" })}
        onChange={(value) => onChange({ title: value })}
      />
      <div className="mt-1 flex flex-wrap items-center gap-2">
        <div className="w-[8.5rem] shrink-0">
          <DatePicker
            id={idPrefix && `${idPrefix}-date`}
            value={event.date}
            aria-label={intl.formatMessage({ id: "project.event.date", defaultMessage: "Datum" })}
            onChange={(date) => onChange({ date })}
          />
        </div>
        <div className="w-[11rem] shrink-0">
          <SearchableSelect
            id={idPrefix && `${idPrefix}-kind`}
            value={event.kind}
            onChange={(value) => onChange({ kind: value as ProjectEventKind })}
            options={PROJECT_EVENT_KINDS.map((kind) => ({
              value: kind,
              label: intl.formatMessage(EVENT_KIND_LABELS[kind]),
            }))}
            searchable={false}
            placeholder={intl.formatMessage({ id: "project.event.kind", defaultMessage: "Art" })}
            ariaLabel={intl.formatMessage({ id: "project.event.kind", defaultMessage: "Art" })}
          />
        </div>
      </div>
    </div>
  );
}
